module.exports = __webpack_public_path__ + "media/images/posts-track-9db2a1915ff02e621bdd3f6c7b8f4f28.jpg";